const mobileSwapX = 1024
let bodyEl = null
let vpWidth = window.innerWidth
let mobileNavIsVisible = false
let navWrapEl = null
let mobileNavBtn = null
let mobileNavOpenIcon = null
let mobileNavCloseIcon = null
let subNavOpenBtn = null
let subNavWrap = null
let subNavCloseBtn = null
let firstNavButton = null
let mainEl = null
let footerUpperEl = null
let footerLowerEl = null


// We need a .closest polyfill for IE9.
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
        var el = this
        do {
            if (el.matches(s)) return el
            el = el.parentElement || el.parentNode
        } while (el !== null && el.nodeType === 1)
        return null
    }
}


export function initialize() {
    bodyEl = document.querySelector('body')
    navWrapEl = document.querySelector('[data-nav-wrap]')
    mobileNavBtn = document.querySelector('[data-mobile-nav-toggle]')
    mainEl = document.querySelector('main')
    footerUpperEl = document.querySelector('.footer__upper')
    footerLowerEl = document.querySelector('.footer__lower')

  if (navWrapEl) {
    mobileNavOpenIcon = mobileNavBtn.querySelector('span:first-of-type')
    mobileNavCloseIcon = mobileNavBtn.querySelector('span:last-of-type')
    firstNavButton = navWrapEl.querySelector('button:first-of-type')
    subNavOpenBtn = [...document.querySelectorAll('[data-sub-nav-open]')]
    subNavWrap = [...document.querySelectorAll('[data-sub-nav-wrap]')]
    subNavCloseBtn = [...document.querySelectorAll('[data-sub-nav-close]')]

    handleDesktopNav()
    addListeners()
    betterResize()
  }
}


export function addListeners() {
    window.addEventListener('resizeViaRAF', handleResize, false)
    document.addEventListener('keydown', handleKeyPresses, false)
    document.addEventListener('click', handleDocClick, false)
    mobileNavBtn.addEventListener('click', toggleMobileNav, false)
    subNavOpenBtn.forEach(function (el) { el.addEventListener('click', toggleAnySubNav, false) })
    subNavCloseBtn.forEach(function (el) { el.addEventListener('click', closeAllSubNavs, false) })
}


// Handle viewport resizing via requestAnimationFrame.
export function betterResize() {
    let running = false
    function doItViaRAF() {
        if (running) { return }
        running = true
        requestAnimationFrame(function () {
            window.dispatchEvent(new CustomEvent('resizeViaRAF'))
            running = false
        })
    }
    window.addEventListener('resize', doItViaRAF)
}


// Utilized when the viewport alternates between mobile and desktop widths.
export function handleResize(event) {
    vpWidth = window.innerWidth

    if (vpWidth >= mobileSwapX) {
      handleDesktopNav()

      if (mobileNavIsVisible) {
        toggleMobileNav(event)
      }

    } else {
      handleMobileNav()
    }
}


// Handle keypresses, especially the escape key.
export function handleKeyPresses(event) {
    if (event.keyCode === 27) {
        closeAllSubNavs()

        if (mobileNavIsVisible) {
            toggleMobileNav(event)
        }
    }

    // If (only) the Tab key is pressed AND the mobile nav is open AND the
    // mobile nav trigger (the hamburger icon) currently has focus…
    if ((event.key === 'Tab' && !event.shiftKey) && mobileNavIsVisible && mobileNavBtn === document.activeElement) {
        // …put focus on the first available button element within the nav.
        event.preventDefault()
        firstNavButton.focus()
    }

    // If the Shift + Tab key combination is pressed AND the mobile nav is open…
    if ((event.key === 'Tab' && event.shiftKey) && mobileNavIsVisible) {
        // …and if the first available button element within the nav currently
        // has focus OR any one of the "BACK" buttons (in the sub-nav) has focus…
        if (firstNavButton === document.activeElement || subNavCloseBtn.some(item => item === document.activeElement)) {
            // …put focus on the mobile nav trigger (the hamburger icon).
            event.preventDefault()
            mobileNavBtn.focus()
        }
    }
}


export function handleDocClick(event) {
    // If the user clicks anywhere except on a sub-nav or a main nav button…
    if (!event.target.closest('[data-sub-nav-wrap], [data-sub-nav-open]')) {
        // …close all sub-navs.
        closeAllSubNavs()
    }
}


// The main navigation has a 'hidden' attribute on it for mobile nav UX, and we
// need to remove that attribute in various situations. This function is called
// on page-load and when the browser is resized.
export function handleDesktopNav() {
    if (vpWidth >= mobileSwapX) {
        navWrapEl.hidden = false
    } else {
        navWrapEl.hidden = true
    }
}

// This is used when the browser is resized from desktop to mobile, and sets
// the UI to "mobile-nav" state. It also ensures it doesn't run again when the
// mobile nav is currently open.
export function handleMobileNav() {
  if (!mobileNavIsVisible) {
    bodyEl.classList.remove('body-fixed-no-overflow')
    mobileNavBtn.setAttribute('aria-expanded', false)
    navWrapEl.hidden = true
    mobileNavOpenIcon.classList.remove('hidden')
  }
}


// Toggle mobile (only) nav.
export function toggleMobileNav(event) {
    mobileNavIsVisible = !mobileNavIsVisible
    bodyEl.classList.toggle('body-fixed-no-overflow')
    mobileNavBtn.setAttribute('aria-expanded', mobileNavIsVisible)
    navWrapEl.hidden = !mobileNavIsVisible
    mobileNavOpenIcon.classList.toggle('hidden')
    mobileNavCloseIcon.classList.toggle('hidden')
    event.stopPropagation()
    closeAllSubNavs()
    if (mobileNavIsVisible) {
        // Make the main body content and the footer content unreachable.
        mainEl.setAttribute('inert', true)
        footerUpperEl.setAttribute('inert', true)
        footerLowerEl.setAttribute('inert', true)
    } else {
        // Revert the above change.
        mainEl.removeAttribute('inert')
        footerUpperEl.removeAttribute('inert')
        footerLowerEl.removeAttribute('inert')
    }
}


// Toggle any sub-nav. Utilized at all viewport widths.
export function toggleAnySubNav() {
    let thisParent = this.closest('[data-nav-group]')
    let thisSubNav = thisParent.querySelector('[data-sub-nav-wrap]')

    if (thisSubNav.hidden) {
        closeAllSubNavs()
        this.setAttribute('aria-expanded', true)
        thisSubNav.hidden = false
    } else {
        this.setAttribute('aria-expanded', false)
        thisSubNav.hidden = true
    }
}


// Close all sub-navs.
export function closeAllSubNavs() {
    subNavOpenBtn.forEach(function (el) {
        if (el.getAttribute('aria-expanded') !== false) {
            el.setAttribute('aria-expanded', false)
        }
    })
    subNavWrap.forEach(function (el) {
        if (!el.hidden) {
            el.hidden = true
        }
    })
}
